import { Injectable } from "@angular/core";
import { firstValueFrom } from "rxjs";
import { OrganizationAccount } from "./OrganizationAccount";
import { ValidateEmail } from "./ValidateOrganizationEmail";
import { PortalAccount } from "../../feature/account/PortalAccount";
import { AdminPortalAPIHttpClient } from "../../infrastructure/http/v2/AdminPortalAPIHttpClient";
import { PortalBeHttpClient } from "../../infrastructure/http/legacy/PortalBeHttpClient";


@Injectable({ providedIn: 'root' })
export class AccountService {

    constructor(
        private readonly adminPortalApiHttpClient: AdminPortalAPIHttpClient,
        private readonly legacyApi: PortalBeHttpClient
    ) {}

    async validateEmail(emailAddress: string): Promise<ValidateEmail> {
        try {
            const response: any = await firstValueFrom(this.adminPortalApiHttpClient.post('/accounts/email-validate', { email_address: emailAddress }));
            if(!response) {
                return Promise.reject(`Validate email address response null ${emailAddress}`);
            }

            return Promise.resolve(response.data);
        } catch (e) {
            return Promise.reject(`Error while validating email address ${emailAddress} ${e}`);
        }
    }

    async updateMemberAccountStatus(accountId: number, status: number): Promise<any> {
        try {
            const response: any = await firstValueFrom(this.adminPortalApiHttpClient.put(`/accounts/update-status/${accountId}`, { status_id: status }));
            if(!response) {
                return Promise.reject(`Update account status response null ${accountId}`);
            }
            return Promise.resolve(response.data);
        } catch (e) {
            return Promise.reject(`Error while updating account status ${accountId}: ${e}`);
        }
    }

    async updateMemberAccountRole(accountId: number, roleId: number): Promise<any> {
        try {
            const response: any = await firstValueFrom(this.adminPortalApiHttpClient.put(`/accounts/update-role/${accountId}`, {
                account_id: accountId,
                role_id: roleId
            }));
            if(!response) {
                return Promise.reject(`Update account status response null ${accountId}`);
            }
            return Promise.resolve(response.data);
        } catch (e) {
            return Promise.reject(`Error while updating account status ${accountId}: ${e}`);
        }
    }

    async getAccountDetail(accountId: number): Promise<OrganizationAccount> {
        try {
            const response: any = await firstValueFrom(this.adminPortalApiHttpClient.get(`/accounts/${accountId}`));
            if(!response) {
                return Promise.reject(`Get account detail response null ${accountId}`);
            }
            return Promise.resolve(response.data);
        } catch (e) {
            return Promise.reject(`Error while getting account details ${accountId} ${e}`);
        }
    }

    async getAccountDetailByUsername(username: string): Promise<PortalAccount> {
        try {
            const response: any = await firstValueFrom(this.legacyApi.get(`/accounts/username/${username}`));
            if (!response) {
                return Promise.reject(`Get account detail by username response null ${username}`);
            }            
            return Promise.resolve(response.data);
        } catch (e) {
            return Promise.reject(`Error while getting account detail by username ${username} ${e}`);
        }
    }

    async updateAccountInfo({ accountId, firstName, middleName, lastName, dateOfBirth, phoneNumber, emailAddress }: any): Promise<OrganizationAccount> {
        try {
            const response: any = await firstValueFrom(this.adminPortalApiHttpClient.put(`/accounts/${accountId}`, {
                first_name: firstName,
                middle_name: middleName,
                last_name: lastName,
                birth_date: dateOfBirth,
                phone_number: phoneNumber,
                email_address: emailAddress.trim(),
                username: emailAddress,
                address: null //not sure if this is needed. The legacy portal always sends null, so copying that here
            }));
            if(!response) {
                return Promise.reject(`Update account response null ${accountId}`);
            }
            return Promise.resolve(response.data);
        } catch (e) {
            return Promise.reject(`Error while updating account ${accountId} ${e}`);
        }
    }
}